export const LANDING_TITLE1 = 'Hola, mi nombre es Joaquín Nieva'
export const LANDING_TITLE2 = 'y soy desarrollador de aplicaciones web'
export const LANDING_TEXT = 'Apretá el siguiente botón para saber más de mí.'
export const LANDING_BUTTON = '¡Conóceme!'
export const BIO_DESCRIPTION =
  'Tengo 22 años y vivo en Córdoba, Argentina. Desarrollo aplicaciones web hace 3 años pero solo 2 en entornos laborales y estudio de forma autodidacta. Estoy apasionado por la tecnología y siempre disfruto aprender lo que más pueda de ella, lo que me hace ser versatil y poder adaptarme.'
export const BIO_BUTTON = 'Descargar CV'
export const PORTFOLIO_TITLE = 'Portafolio'
export const CODER_TITLE = 'Habilidades'
export const CODER_DESCRIPTION =
  'Las tecnologías que se mencionan están completamente estudiadas, el progreso de la barra comprende la facilidad y rapidez con la que me desenvuelvo.'
export const DESIGNER_TITLE = 'Diseño'
export const DESIGNER_DESCRIPTION =
  'En el diseño trabajo con estos programas, el progreso de las barras comprende mi conocimiento y manejo con los mismos.'
export const TITLE_PROYECTS = 'Proyectos'
export const REPO = 'Repo'
export const DEMO = 'Demo'
export const CONTACT_TITLE = 'CONTACTO'
export const CONTACT_COPYRIGHT = 'Copyright © Todos los derechos reservados'
